import React from "react";
import styles from "./RadioButton.module.css";
import PropTypes from "prop-types";

export function RadioButton({ isSelected, value, onChange, name }) {
  return (
    <div className={styles.radioDiv}>
      <input
        type="radio"
        name={name}
        value={value}
        className={styles.radioBtn}
        onChange={onChange}
        // onChange={() => onChange(!isSelected)}
        checked={isSelected}
      />
      <label className={styles.label}>{value}</label>
    </div>
  );
}

RadioButton.propTypes = {
  value: PropTypes.string,
  /**
   * Boolean that determines if the option is selected.
   */
  isSelected: PropTypes.bool,
  /**
   *  Function that sets the value of the currently selected option.
   */
  onChange: PropTypes.func,
};
